import { Order, ORDER_SOURCE_IDS } from "../../../../services/orders/orders.types";

export const canCancel = (order: Order): boolean => order.source !== ORDER_SOURCE_IDS.lcr;
